import { DyteNameTag, DyteParticipantTile } from "@dytesdk/react-ui-kit";
import { useDyteMeeting } from "@dytesdk/react-web-core";
import { MicOff, VideoOff } from "lucide-react";

interface UserVideoTileProps {
  isVideoOn: boolean;
  isMicOn: boolean;
}

export default function UserVideoTile({
  isVideoOn,
  isMicOn,
}: UserVideoTileProps) {
  const { meeting } = useDyteMeeting();

  return (
    <div className="absolute right-4 top-20 h-36 w-48 overflow-hidden rounded-lg border-2 border-white/20 bg-gray-700 shadow-lg">
      <div className="relative flex size-full items-center justify-center bg-gradient-to-br from-primary/30 to-primary/60">
        {isVideoOn && meeting?.self ? (
          <DyteParticipantTile
            participant={meeting.self}
            meeting={meeting}
            nameTagPosition="bottom-left"
            style={{
              borderRadius: "12px",
              width: "100%",
              height: "100%",
              backgroundColor: "transparent",
            }}
          >
            <DyteNameTag participant={meeting.self} meeting={meeting} />
          </DyteParticipantTile>
        ) : (
          <div className="flex flex-col items-center gap-2 text-white">
            <VideoOff className="size-8" />
            <span className="text-sm">Camera Off</span>
          </div>
        )}
        {/* User Name Overlay */}
        <div className="absolute bottom-2 left-2 rounded bg-black/50 px-2 py-1 backdrop-blur-sm">
          <div className="flex items-center gap-1 text-white">
            <div className="size-1.5 rounded-full bg-green-400"></div>
            <span className="text-xs">You</span>
          </div>
        </div>
        {/* Mic Status on User Video */}
        {!isMicOn && (
          <div className="absolute right-2 top-2 rounded-full bg-red-500 p-1">
            <MicOff className="size-3 text-white" />
          </div>
        )}
      </div>
    </div>
  );
}
